import { Grid } from '@mui/material';
import formatCNPJ from '../../../utils/functions/formatCNPJ';
import formatCPF from '../../../utils/functions/formatCPF';

const NameAndDocumentIdGrid = ({ name, documentId }) => {

  return (
    <Grid container>
      <Grid item xs={12}>
        {name && name.length > 0 ? name : '----'}
      </Grid>
      <Grid item xs={12}>
        {documentId && ( documentId.length > 11 ? formatCNPJ(documentId) : formatCPF(documentId))}
      </Grid>
    </Grid>
  );
};

export default NameAndDocumentIdGrid;
